module.exports = __webpack_public_path__ + "img/s3-v2.fa20bfef.png";